import { Box, FormLabel } from "@mui/material";
import TooltipPopover from "../../../../components/shared/others/TooltipPopover";

const TooltipInvoiceType = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TooltipPopover>
                <b>Com vínculo:</b><br />
                O sistema lista automaticamente as atividades já feitas para o cliente selecionado.
                Ao escolher uma atividade para incluir na fatura, os Serviços,
                Peças e Materiais preenchidos na execução aparecem automaticamente.
                <br /><br />
                <b>Sem vínculo:</b><br />
                Você escolhe manualmente quais Serviços, Peças e Materiais devem ser
                incluídos na fatura do cliente sem precisar associar a uma atividade.
            </TooltipPopover>
        </Box>
    )
}

export default TooltipInvoiceType;